/*
 * @Author: Wang Wenmao
 * @Date: 2023-09-21 14:21:29
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2024-01-04 13:31:12
 * @Description: 商品参数展示配置
 */

import React, { Fragment, useState, useEffect } from 'react';
import { Spin, Button, Form, Input, Table, Popconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import './index.less';

const { api } = services;

const Index = () => {
    const columns: any = [
        {
            title: '品类模板',
            dataIndex: 'attrName',
            key: 'attrName',
        },
        {
            title: '参数数量',
            dataIndex: 'attrCount',
            key: 'attrCount',
        },
        {
            title: '状态',
            dataIndex: 'attrStatus',
            key: 'attrStatus',
            render(text: string) {
                const className =
                    +text === 0 ? 'ant-badge-status-success' : 'ant-badge-status-error';
                const status = +text === 0 ? '启用' : '禁用';
                return (
                    <div>
                        <span className={`ant-badge-status-dot ${className}`} />
                        <span style={{ marginLeft: '8px' }}>{status}</span>
                    </div>
                );
            },
        },
        {
            title: '操作',
            dataIndex: 'x',
            key: 'x',
            align: 'center',
            render: (_: any, item: any) => {
                const status = +item.attrStatus === 0 ? '禁用' : '启用';
                return (
                    <Fragment>
                        <Button type="link" onClick={() => handleEdit(item)}>
                            编辑
                        </Button>
                        <Popconfirm
                            placement="top"
                            title={`您确定要${status}吗？`}
                            onConfirm={() => confirm(item)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button type="link">{status}</Button>
                        </Popconfirm>
                    </Fragment>
                );
            },
        },
    ];

    const [loading, setLoading] = useState(false);
    const [inpVlue, setInpVlue] = useState('');
    const [current, setCurrent] = useState(1); // 当前页
    const [pageSize, setPageSize] = useState(10); // 每页条数
    const [dataSource, setDataSource] = useState([]); // 表格数据

    const pagination = {
        current,
        pageSize,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '50', '100'],
        showTotal: (total: number) => `共 ${total} 条记录`,
        onChange: (current: number) => setCurrent(current),
        onShowSizeChange: (current: number, pageSize: number) => {
            setCurrent(current);
            setPageSize(pageSize);
        },
    };

    useEffect(() => getZHPPLList(), []);

    // 获取表格数据
    const getZHPPLList = () => {
        const apiPath = `/products/getZHPPLList?search_content=${inpVlue}`;
        setLoading(true);
        api.get({}, { apiPath })
            .then((res: any) => setDataSource(res))
            .catch(errorHandle)
            .finally(() => setLoading(false));
    };

    // 编辑
    const handleEdit = (item: any) => {
        window.location.href = `/#/product/display-location-info/${item.optionCode}`;
    };

    // 查询
    const handleSearch = (type: string) => {
        if (type === '1') {
            setInpVlue('');
        }
        getZHPPLList();
    };

    // 设置启用禁用
    const confirm = (item: any) => {
        const attr_status = +item.attrStatus === 0 ? 1 : 0;
        const apiPath = `/products/updateZHPPLStatus?attr_status=${attr_status}&option_code=${item.optionCode}`;
        api.put({}, { apiPath })
            .then(getZHPPLList)
            .catch(errorHandle);
    };

    return (
        <div className="display-location">
            <Spin spinning={loading}>
                <div className="display-location-search">
                    <div>
                        <span>品类模板：</span>
                        <Input
                            value={inpVlue}
                            style={{ width: 300, marginBottom: '10px' }}
                            placeholder="请输入销售订单"
                            onChange={(v) => setInpVlue(v.target.value)}
                            onPressEnter={() => handleSearch('0')}
                        />
                    </div>
                    <div>
                        <Button
                            style={{ marginLeft: 16 }}
                            type="primary"
                            onClick={() => handleSearch('0')}
                        >
                            查询
                        </Button>
                        <Button style={{ marginLeft: 16 }} onClick={() => handleSearch('1')}>
                            重置
                        </Button>
                    </div>
                </div>
                <Table
                    rowKey="optionCode"
                    columns={columns}
                    dataSource={dataSource}
                    pagination={pagination}
                />
            </Spin>
        </div>
    );
};

export const DisplayLocation = Form.create()(Index);
